import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { AdminService } from '@shared/services/admin.service';

import { validateFormGroup } from '@shared/utils/form.util';

import { AuthenticationService } from '@core/services/authentication.service';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {PropertiesService} from "@core/services/properties.service";

@UntilDestroy()
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {
  routeActive: boolean;

  loginForm: FormGroup;
  loading = false;
  azureDataloading = false;
  oktaDataloading = false;
  error = false;
  lockError = false;

  loginPasswordVisible = false;

  oktaData: AdminSettings.BaseAdminModel<AdminSettings.Okta>;
  azureData: AdminSettings.BaseAdminModel<AdminSettings.Azure>;
  baseUrl: string;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private propertiesService: PropertiesService,
    private adminService: AdminService,
    private authenticationService: AuthenticationService
  ) { this.baseUrl = window.location.origin;
    router.events.pipe(untilDestroyed(this)).subscribe(evt => {
      if ((evt instanceof NavigationEnd)) {
        this.routeActive = evt.url === '/login';
        if (this.routeActive) {
          if (this.propertiesService.PLAYGROUND) {
            this.router.navigateByUrl('/playground-register');
          } else {
            this.router.navigateByUrl('/');
          }
        }
      }
    });
  }

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      username: [null, [Validators.required]],
      password: [null, [Validators.required]],
      remember: [false]
    });

    this.azureDataloading = true;
    this.oktaDataloading = true;
    this.adminService.getAzureSettings()
      .pipe(untilDestroyed(this))
      .subscribe(response => {
        this.azureData = response;
        this.azureDataloading = false;
      }, error => {
        this.azureDataloading = false;
        console.log('error while fetching azure ad settings', error);
      });


      this.adminService.getOktaSettings()
      .pipe(untilDestroyed(this))
      .subscribe(response => {
        this.oktaData = response;
        this.oktaDataloading = false;
      }, error => {
        this.oktaDataloading = false;
        console.log('error while fetching okta ad settings', error);
      });
  }

  submitForm(): void {
    if (this.loading) {
      return;
    }

    validateFormGroup(this.loginForm);

    if (this.loginForm.invalid) {
      return;
    }

    const data = {
      username: this.loginForm.value.username,
      password: this.loginForm.value.password
    };

    this.loading = true;
    this.authenticationService.login(data).pipe(untilDestroyed(this)).subscribe(() => {
    }, error => {
      if (error.status === 401) {
        this.error = true;
      } else if (error.status === 400) {
        this.error = false;
        this.lockError = true;
      } else {
        this.error = false;
        this.lockError = false;
      }
      this.loading = false;
      console.log('error while logging in', error);
    });
  }

  submitFormAzure(): void {
    if (this.azureDataloading) {
      return;
    }

    window.location.href = `https://login.microsoftonline.com/${this.azureData?.settings?.tenantId}/oauth2/authorize?client_id=${this.azureData?.settings?.clientId}&response_type=id_token&redirect_uri=${this.baseUrl}/&state=b597dbdf-7c80-4aa2-bb4e-6e76a100cffe&x-client-SKU=Js&x-client-Ver=1.0.17&nonce=7362CAEA-9CA5–4B43–9BA3–34D7C303EBA7`;
  }

  submitFormOkta(): void {
    if (this.oktaDataloading) {
      return;
    }
    window.location.href = this.oktaData?.settings?.ssoUrl;
  }
}
